import React from 'react';
import { Button } from 'antd';

const ChartEmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  height,
  minHeight = 200,
  tone = 'default',
}) => {
  const resolvedHeight = height ?? minHeight;

  if (tone === 'subtle') {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: resolvedHeight,
          minHeight: resolvedHeight,
          boxSizing: 'border-box',
          padding: '32px 24px',
        }}
      >
        {Icon ? (
          <Icon
            style={{
              fontSize: 28,
              marginBottom: 10,
              opacity: 0.18,
              color: 'var(--color-text-muted)',
            }}
          />
        ) : null}
        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--color-text-muted)',
            textAlign: 'center',
            lineHeight: 1.5,
          }}
        >
          {title}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: resolvedHeight,
        minHeight: resolvedHeight,
        boxSizing: 'border-box',
      }}
    >
      <div className="empty-state" style={{ padding: '40px 20px' }}>
        {Icon ? <Icon className="empty-state-icon" /> : null}
        <div className="empty-state-title">{title}</div>
        {description ? (
          <div className="empty-state-description" style={{ marginBottom: actionLabel ? 16 : 0 }}>
            {description}
          </div>
        ) : null}
        {actionLabel && onAction ? (
          <Button type="primary" className="empty-state-action" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default ChartEmptyState;
